import { Node } from "@iventis/domain-model/model/node";
import { libraryApi } from "@iventis/api/src/api";

export const getSpatialLibraries = async (signal?: AbortSignal) => (await libraryApi.get<Node[]>(`/spatial`, { signal }))?.data;
